$(function () {
    $(document).on('click', '.confirm-this', function(ev){
        var message = $(this).data('confirm-text');
        if(!confirm(message)) {
            ev.preventDefault();
        }
    });
});
